import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
import 'font-awesome/css/font-awesome.min.css'
import VueResource from 'vue-resource';

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueResource);

//NProgress.configure({ showSpinner: false });

// Array.prototype.contains = function(obj) {
//   var i = this.length;
//   while (i--) {
//     if (this[i] === obj) {
//       return true;
//     }
//   }
//   return false;
// }

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else if (user && user.rname !== 'ROLE_PLATFORM' && user.rname !== 'ROLE_ADMIN' && user.rname !== 'ROLE_DEMO' && to.path === '/dashboard') {
    next({ path: '/login' })
  } else if (user && user.rname !== 'ROLE_ADMIN' && to.path.startsWith('/settings')) {
    next({ path: '/login' })
  } else {
    next()
  }
})

//router.afterEach(transition => {
//NProgress.done();
//});

require('../node_modules/echarts/map/js/china.js')

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js